// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__4jFvl","modalFooterButton":"ModalNotes_modalFooterButton__n2f0r"};